export default {
    steam_link_success: "Bind success",
    steam_unlink_success: "Unbind success",
    steam_linked: "Linked",
};
